import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, CheckCircle2 } from "lucide-react";
import api from "../../lib/api";

export const MessagesAdmin = () => {
  const [messages, setMessages] = useState([]);

  const load = () => api.get("/admin/messages").then((res) => setMessages(res.data));

  useEffect(() => {
    load();
  }, []);

  const markHandled = async (id) => {
    await api.patch(`/admin/messages/${id}`, { status: "tratado" });
    toast.success("Marcado como tratado.");
    load();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Eliminar esta mensagem?")) return;
    await api.delete(`/admin/messages/${id}`);
    toast.success("Mensagem eliminada.");
    load();
  };

  return (
    <div data-testid="messages-list" className="space-y-4">
      {messages.length === 0 && <p className="text-black/30 font-light">Sem mensagens.</p>}
      {messages.map((m) => (
        <div key={m.id} data-testid={`message-card-${m.id}`} className="bg-white border border-black/5 p-6 flex flex-col md:flex-row md:items-start gap-4">
          <div className="flex-1">
            <div className="flex flex-wrap items-center gap-3">
              <p className="font-medium">{m.name}</p>
              <span
                className={`text-xs uppercase tracking-widest px-2 py-0.5 ${
                  m.status === "tratado" ? "bg-black text-white" : "border border-black/20 text-black/60"
                }`}
              >
                {m.status || "novo"}
              </span>
              <span className="text-xs text-black/40 font-light">
                {new Date(m.created_at).toLocaleString("pt-PT")}
              </span>
            </div>
            <p className="text-sm text-black/50 mt-1 font-light">
              {m.email}
              {m.phone ? ` · ${m.phone}` : ""}
            </p>
            <p className="mt-3 text-sm font-light leading-relaxed">{m.message}</p>
          </div>
          <div className="flex gap-2 shrink-0">
            {m.status !== "tratado" && (
              <button
                data-testid={`message-handle-${m.id}`}
                onClick={() => markHandled(m.id)}
                className="label-editorial border border-black/20 px-4 py-2.5 hover:border-black transition-colors flex items-center gap-2"
              >
                <CheckCircle2 size={14} /> Tratado
              </button>
            )}
            <button
              data-testid={`message-delete-${m.id}`}
              onClick={() => handleDelete(m.id)}
              className="p-2.5 border border-black/10 hover:border-red-600 text-red-600 transition-colors"
              aria-label="Eliminar"
            >
              <Trash2 size={15} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
